export const isFilterCleared = (filterValue) => {
  if (!filterValue) return true;
  if (Array.isArray(filterValue) && filterValue.length === 0) return true;
  return false;
};
